import React, { useState, useEffect } from "react";
import API_URL from "../apiConfig";
import "../styles/SalaryManagement.css";

export default function SalaryPaymentModal({ token, user, onClose }) {
  const [staffList, setStaffList] = useState([]);
  const [form, setForm] = useState({
    staff_id: "",
    month: "",
    year: "",
    basic_pay: "",
    allowances: "",
    deductions: "",
    net_pay: "",
    payment_date: "",
    mode: "cash",
    remarks: ""
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetch(`${API_URL}/api/staff`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setStaffList(Array.isArray(data) ? data : []));
  }, [token]);

  useEffect(() => {
    const basic = Number(form.basic_pay) || 0;
    const allowances = Number(form.allowances) || 0;
    const deductions = Number(form.deductions) || 0;
    setForm(f => ({ ...f, net_pay: (basic + allowances - deductions).toFixed(2) }));
  }, [form.basic_pay, form.allowances, form.deductions]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    if (!form.staff_id || !form.month || !form.year || !form.basic_pay || !form.net_pay || !form.payment_date || !form.mode) {
      setMessage("Required fields missing.");
      setLoading(false);
      return;
    }
    try {
      const res = await fetch(`${API_URL}/api/salary_expense`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (data.error) setMessage(data.error);
      else {
        setMessage("Salary payment recorded!");
        setTimeout(onClose, 1000);
      }
    } catch {
      setMessage("Failed to process salary.");
    }
    setLoading(false);
  };

  return (
    <div className="modal-bg">
      <div className="modal">
        <form className="salary-form" onSubmit={handleSubmit}>
          <h3>Process Salary</h3>
          <div>
            <label>Staff *</label>
            <select name="staff_id" value={form.staff_id} onChange={handleChange} required>
              <option value="">Select Staff</option>
              {staffList.map(s => <option key={s.id} value={s.id}>{s.name} ({s.position})</option>)}
            </select>
          </div>
          <div>
            <label>Month *</label>
            <select name="month" value={form.month} onChange={handleChange} required>
              <option value="">Month</option>
              {["01","02","03","04","05","06","07","08","09","10","11","12"].map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
          <div>
            <label>Year *</label>
            <input name="year" type="text" maxLength={4} value={form.year} onChange={handleChange} placeholder="YYYY" required />
          </div>
          <div>
            <label>Basic Pay *</label>
            <input name="basic_pay" type="number" min="0" value={form.basic_pay} onChange={handleChange} required />
          </div>
          <div>
            <label>Allowances</label>
            <input name="allowances" type="number" min="0" value={form.allowances} onChange={handleChange} />
          </div>
          <div>
            <label>Deductions</label>
            <input name="deductions" type="number" min="0" value={form.deductions} onChange={handleChange} />
          </div>
          <div>
            <label>Net Pay *</label>
            <input name="net_pay" type="number" min="0" value={form.net_pay} onChange={handleChange} required readOnly style={{ background: "#eee" }} />
          </div>
          <div>
            <label>Payment Date *</label>
            <input name="payment_date" type="date" value={form.payment_date} onChange={handleChange} required />
          </div>
          <div>
            <label>Mode *</label>
            <select name="mode" value={form.mode} onChange={handleChange} required>
              <option value="cash">Cash</option>
              <option value="bank">Bank</option>
              <option value="online">Online</option>
            </select>
          </div>
          <div>
            <label>Remarks</label>
            <input name="remarks" type="text" value={form.remarks} onChange={handleChange} />
          </div>
          {message && <div style={{color:"red"}}>{message}</div>}
          <div style={{marginTop: 18}}>
            <button type="submit" disabled={loading}>{loading ? "Saving..." : "Add"}</button>
            <button type="button" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}